import { useQuery, useQueryClient } from '@tanstack/react-query';
import { useState } from 'react';
import { toast } from 'sonner';
import { rolesEditService } from '../services/rolesEdit.service';
import type { RoleEditData } from '../types/rolesEdit.types';

export function useRolesEdit(id: string | null) {
  const queryClient = useQueryClient();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const roleQuery = useQuery({
    queryKey: ['settings', 'roles', 'detail', id],
    queryFn: () => rolesEditService.getRoleById(id || ''),
    enabled: Boolean(id),
  });

  const updateRole = async (data: Partial<RoleEditData>) => {
    if (!id) return false;
    if (!data.name?.trim()) {
      toast.error('Vui lòng nhập tên vai trò');
      return false;
    }

    setIsSubmitting(true);
    try {
      await rolesEditService.updateRole(id, data);
      await queryClient.invalidateQueries({ queryKey: ['settings', 'roles'] });
      toast.success('Đã lưu thay đổi');
      return true;
    } catch (error) {
      toast.error(error instanceof Error ? error.message : 'Không thể lưu thay đổi');
      return false;
    } finally {
      setIsSubmitting(false);
    }
  };

  return {
    role: roleQuery.data || null,
    availableModules: rolesEditService.getAvailablePermissions(),
    isLoading: roleQuery.isLoading,
    isSubmitting,
    updateRole,
  };
}
